import axios from './http'
import jwt_decode from "jwt-decode";
import store from './store'
import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/Index.vue'
import Nofind from './views/404'
import Login from './views/Login'
import LoginPhone from './views/LoginPhone'
import Home from './views/Home'
import ExamPC from './views/ExamPC'
import ExamPhone from './views/ExamPhone'
import PersonCenter from './views/PersonCenter'
import ArticleShow from './views/ArticleShow'
import TeacherList from './views/TeacherList'
import PaperList from './views/PaperList'
import RecordList from './views/RecordList'
import AchievementView from './views/AchievementView'
import MisTakesList from './views/MisTakesList'
import CourseDetail from './views/CourseDetail'
import CourseList from './views/CourseList'
import MyCourseList from './views/MyCourseList'
import MyLive from './views/MyLive'
import LiveViews from './views/LiveViews'
import QueryInfo from './views/QueryInfo'
import QueryResult from './views/QueryResult'
import ExamPCSingle from './views/ExamPC'
import Show from './views/Show.vue'
import Inquery from './views/Inquery.vue'
import NewsViews from './views/listinfo/NewsViews.vue'
import NewsInfo from './views/listinfo/NewsInfo.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkExactActiveClass: "selected",
  base: process.env.BASE_URL,
  routes: [{
    path: '*',
    name: '/404',
    component: Nofind
  },
  {
    path: '/show',
    name: 'Show',
    component: Show,
  }, {
    path: '/inquery',
    name: 'inquery',
    component: Inquery,
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/kscx',
    name: 'queryinfo',
    component: QueryInfo
  },
  {
    path: '/queryResult',
    name: 'queryResult',
    component: QueryResult
  },

  {
    path: '/exam/:id',
    name: 'exam',
    component: ExamPhone
  },
  {
    path: '/achieveview/:id', //测评记录
    name: 'AchievementView',
    component: AchievementView
  },
  {
    path: '/',
    name: 'index',
    component: Index,
    children: [{
      path: '',
      component: Home
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/personcenter',
      name: 'personcenter',
      component: PersonCenter
    },
    {
      path: '/views/info/:plateId/:articleId', //显示文章内容
      name: 'infoArticle',
      component: NewsInfo
    },
    {
      path: '/views/:plateId', //显示更多文章
      name: 'TeacherList',
      component: TeacherList
    },
    {
      path: '/papercenter', //测评中心
      name: 'PaperList',
      component: PaperList
    },
    {
      path: '/examrecord', //测评记录
      name: 'RecordList',
      component: RecordList
    },
    {
      path: '/mistakelist', //错题卡
      name: 'MisTakesList',
      component: MisTakesList
    },
    {
      path: '/courview/info/:id', //课程详情页
      name: 'CourseDetail',
      component: CourseDetail
    }, {
      path: '/courviews', //课程详情页
      name: 'CourseList',
      component: CourseList
    }, {
      path: '/mycourses', //课程详情页
      name: 'MyCourseList',
      component: MyCourseList
    }, {
      path: '/liveview', //课程详情页
      name: 'LiveViews',
      component: LiveViews
    }, {
      path: '/mylive/:id', //直播详情页
      name: 'MyLive',
      component: MyLive
    },
    {
      path: '/exampc/:id',
      name: 'exampc',
      component: ExamPC
    },
    {
      path: '/examsigl/:id',
      name: 'exampc',
      component: ExamPCSingle
    },
    {
      path: '/listView/:plateId',
      name: 'NewsViews',
      component: NewsViews
    },
    {
      path: '/news/info/:plateId/:articleId', //显示文章内容
      name: 'NewsInfo',
      component: NewsInfo
    }
    ]
  },

  ]
})

//添加路由守卫
router.beforeEach((to, from, next) => {
  let userid = to.query.userid;
  let password = to.query.password;
  if (userid && password) {
    //处理业务逻辑
    axios.post("/api/auth/login", {
      identificationcard: userid,
      password: password,
    }).then((res) => {
      // 登录成功
      const self = this;
      const { token } = res.data;
      localStorage.setItem("eleTokenWrd001", token);

      // 解析token
      const decode = jwt_decode(token);
      // 存储数据
      store.dispatch("setIsAutnenticated", !isEmpty(decode));
      store.dispatch("setUser", decode);
      let arrhasCourse = [];
      for (var i = 0; i < res.data.data.needexaminee.length; i++) {
        arrhasCourse.push(res.data.data.needexaminee[i].coursetype);
      }
      this.$root.hasCourse = arrhasCourse;
      this.$root.ischeckface = res.data.data.ischeckface;
      this.$root.onlymycourse = res.data.data.onlymycourse;
      this.$root.buytype = res.data.data.buytype;
      if (res.data.data.onlymycourse)
        localStorage.setItem("onlymycourseWrd", "1");
      else
        localStorage.setItem("onlymycourseWrd", "0");
      localStorage.setItem("hasCourseWrd", arrhasCourse.join(","));
      // 页面跳转
      next("/");
    }).catch(err => {
      console.log(err)
      next("/");
    });
  } else {
    const isLogin = localStorage.eleTokenWrd001 ? true : false;
    if (to.path == "/login" || to.path == "/resetpin") {
      next();
    } else {
      // isLogin ? next() : next("/login");
      next();
    }
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

})
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
function isEmpty(value) {
  return (
    value === undefined ||
    value === null ||
    (typeof value === "object" && Object.keys(value).length === 0) ||
    (typeof value === "string" && value.trim().length === 0)
  );
}
function isPhone() {
  var mobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return mobile != null
}
export default router;